var DataTestIds = /* @__PURE__ */ ((DataTestIds2) => {
  DataTestIds2["OpenAppointmentCard"] = "open-appointment-card";
  return DataTestIds2;
})(DataTestIds || {});
export {
  DataTestIds
};
